// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoPanel {
    padding: 1rem;
    word-wrap: break-word;
    word-wrap: break-word;
}

.buttonPanel {
    margin-top: 1rem;
}

div {
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./fablesite/js/Components/AliasInfoPanel/AliasInfoPanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb","sourcesContent":[".infoPanel {\n    padding: 1rem;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n}\n\n.buttonPanel {\n    margin-top: 1rem;\n}\n\ndiv {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
